// Final client-document projection of the options read contract. Never modify
// editor options or calculate prices here; uncertain joins stop document output.
import { orderedItems, orderedSections } from './quote-line-structure';
const hidden = (value) => value?.isClientVisible === false || value?.is_client_visible === false;
const uncertain = () => Object.assign(new Error('Visibilité du document client non vérifiable. Une vérification des options est nécessaire.'),
  { code: 'QUOTE_CLIENT_VISIBILITY_UNVERIFIABLE' });

export const clientOptionDocumentViews = (sources = [], results = []) => {
  if (!results.length) return [];
  const options = new Map();
  orderedItems(sources || []).forEach((option) => {
    const id = option.id ?? option.clientId;
    if (id == null || options.has(String(id))) throw uncertain();
    options.set(String(id), option);
  });
  const optionRank = new Map([...options.keys()].map((id, index) => [id, index]));
  return [...results].sort((a, b) => optionRank.get(String(a.id)) - optionRank.get(String(b.id))).flatMap((result) => {
    const source = options.get(String(result.id));
    if (!source) throw uncertain();
    if (hidden(source)) return [];
    const sections = new Map();
    const collect = (items, parent = null) => (items || []).forEach((section) => {
      if (section.id == null || sections.has(String(section.id))) throw uncertain();
      sections.set(String(section.id), { section, parent: section.parentSectionId ?? section.parent_section_id ?? parent });
      collect(section.children, String(section.id));
    });
    collect(source.sections);
    const sectionHidden = (id, path = new Set()) => {
      const node = sections.get(id);
      if (!node || path.has(id)) throw uncertain();
      if (hidden(node.section)) return true;
      return node.parent == null ? false : sectionHidden(String(node.parent), new Set([...path, id]));
    };
    const lines = new Map();
    const ordered = orderedSections([...sections].map(([id, node]) => ({ ...node.section, id, parentSectionId: node.parent })), () => { throw uncertain(); });
    ordered.forEach((section) => {
      const id = String(section.id);
      const hideSection = sectionHidden(id);
      orderedItems(section.lines || []).forEach((line) => {
        if (line.id == null || lines.has(String(line.id))) throw uncertain();
        lines.set(String(line.id), hideSection || hidden(line));
      });
    });
    const rank = new Map([...lines.keys()].map((id, index) => [id, index]));
    const visible = [...(result.lines || [])].sort((a, b) => rank.get(String(a.id)) - rank.get(String(b.id))).filter((line) => {
      if (!lines.has(String(line.id))) throw uncertain();
      return !lines.get(String(line.id));
    }).map(({ id, description, label, quantity, unit, sellingPriceHT, vatAmount, sellingPriceTTC }) =>
      ({ id, description: description || label, quantity, unit, sellingPriceHT, vatAmount, sellingPriceTTC }));
    return [{ id: result.id, title: result.title, selected: result.selected,
      totals: { totalHT: result.totals?.totalHT, totalVat: result.totals?.totalVat, totalTTC: result.totals?.totalTTC },
      taxBreakdown: (result.taxBreakdown || []).map(({ rate, base_ht, tax_amount, total_ttc }) => ({ rate, base_ht, tax_amount, total_ttc })),
      taxCalculationMethod: result.taxCalculationMethod, taxAllocationMethod: result.taxAllocationMethod, lines: visible }];
  });
};
